var _g, _circle, _circle2, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissingInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1283:29276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7993 12.792C16.7871 8.48594 14.0971 4.19439 9.79102 3.20658C5.48493 2.21878 1.19338 4.90878 0.205577 9.21486C-0.782231 13.5209 1.90777 17.8125 6.21385 18.8003C10.5199 19.7881 14.8115 17.0981 15.7993 12.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99926 14.2835C9.71772 14.2835 11.1108 12.354 11.1108 9.9738C11.1108 7.5936 9.71772 5.66406 7.99926 5.66406C6.28079 5.66406 4.8877 7.5936 4.8877 9.9738C4.8877 12.354 6.28079 14.2835 7.99926 14.2835Z",
    fill: "#011133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95003 14.0078C5.34615 14.0078 3.0165 14.6316 1.46875 15.6136C2.20452 16.6555 3.17887 17.5062 4.31045 18.0948C5.44202 18.6834 6.69798 18.9927 7.97346 18.9969C9.24894 19.0011 10.5069 18.7002 11.6424 18.1191C12.7778 17.5381 13.7578 16.6938 14.5005 15.6569C12.9527 14.6501 10.5934 14.0078 7.95003 14.0078Z",
    fill: "#011133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47387 10.9961H7.52521C6.86893 10.9961 6.33691 11.5281 6.33691 12.1844V14.8883C6.33691 15.5446 6.86893 16.0766 7.52521 16.0766H8.47387C9.13015 16.0766 9.66217 15.5446 9.66217 14.8883V12.1844C9.66217 11.5281 9.13015 10.9961 8.47387 10.9961Z",
    fill: "#011133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37902 10.2214C5.47166 10.9131 5.3185 11.5122 5.03563 11.5604C4.75276 11.6086 4.44889 11.0861 4.35625 10.3956C4.26361 9.70506 4.41554 9.10598 4.69841 9.0578C4.98128 9.00963 5.28514 9.52595 5.37902 10.2214Z",
    fill: "#011133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6204 10.2214C10.5265 10.9131 10.6797 11.5122 10.9626 11.5604C11.2454 11.6086 11.5493 11.0861 11.6432 10.3956C11.737 9.70506 11.5826 9.10598 11.2998 9.0578C11.0169 9.00963 10.713 9.52595 10.6204 10.2214Z",
    fill: "#011133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00018 9.80557C4.89477 9.11466 4.79019 8.42457 4.68643 7.73531C4.64813 7.48827 4.61108 7.22022 4.70249 6.98429C4.79389 6.74836 5.06194 6.55937 5.30034 6.64831C5.20523 6.16904 5.73638 5.81452 6.19836 5.66012C6.97151 5.37683 7.79942 5.27498 8.61818 5.36243C9.43981 5.45452 10.2022 5.83484 10.77 6.43585C10.9488 6.62395 11.0871 6.84678 11.1764 7.09052C11.3357 7.56362 11.2344 8.07871 11.1319 8.5728L10.8848 9.73763C10.8733 9.82723 10.8389 9.91233 10.7848 9.98468C10.6884 10.0921 10.5254 10.0996 10.3809 10.0996L5.7512 10.1107C5.46092 10.1107 5.08294 10.039 5.04464 9.75122",
    fill: "#011133"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11,
    r: 7.5,
    stroke: "#EEA10D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7646,
    cy: 4.41108,
    r: 4.23529,
    fill: "#EEA10D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1416,
    y: 2.16797,
    width: 1.24567,
    height: 3.3218,
    rx: 0.622837,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1416,
    y: 5.90625,
    width: 1.24567,
    height: 1.24567,
    rx: 0.622837,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1283:29276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingInformationIcon);
export default __webpack_public_path__ + "static/media/missing-information-icon.7031c1b71ca2b2061139d6dccf44cf6d.svg";
export { ForwardRef as ReactComponent };